import React from 'react';
import V1CTAButton from './V1CTAButton';
import './V1SolutionSection.css';

interface V1SolutionSectionProps {
  theme: 'premium' | 'energetic';
  onCTAClick: () => void;
}

const V1SolutionSection: React.FC<V1SolutionSectionProps> = ({ theme, onCTAClick }) => {
  const features = [
    { icon: '📋', title: 'Ustrukturyzowany 8-tygodniowy plan', description: 'Dokładnie wiemy, co robić i kiedy' },
    { icon: '🧘', title: 'Techniki zarządzania stresem', description: 'Naucz się radzić z presją egzaminacyjną' },
    { icon: '✅', title: 'Sprawdzona metodyka', description: '98% naszych uczniów zdaje powyżej oczekiwań' }
  ];

  return (
    <section className="v1-solution-section v1-section">
      <div className="v1-container">
        <h2 className="v1-section-title v1-animate-in">
          {theme === 'premium' ? 'Nasza Metoda' : '💡 NASZA METODA'}
        </h2>
        <p className="v1-section-subtitle v1-animate-in" style={{ animationDelay: '0.2s' }}>
          Sprawdzone podejście, które eliminuje stres i gwarantuje wyniki
        </p>

        <div className="v1-solution-grid">
          {features.map((feature, index) => (
            <div key={index} className="v1-solution-card v1-glass v1-animate-in" style={{ animationDelay: `${0.4 + index * 0.1}s` }}>
              <div className="v1-solution-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="v1-solution-cta v1-animate-in" style={{ animationDelay: '0.8s' }}>
          <V1CTAButton variant="secondary" size="large" theme={theme} onClick={onCTAClick}>
            Dołącz do 500+ uczniów
          </V1CTAButton>
        </div>
      </div>
    </section>
  );
};

export default V1SolutionSection;
